import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import ReusableButton from '../../../SharedComponents/Button/Button'
import ReusableTextBox from '../../../SharedComponents/Textbox/Textbox'
import Loading from '../../../Images/loading.gif'
import '../../../CSS/global.css'
import { CloseIcon } from '../../../Images/CloseIcon.svg'
import './DashboardScheduleUploadDownload.css'
import { destroySession } from '../../../Utility/Utility';
import * as DashboardScheduleUploadDownloadConstant from './DashboardScheduleUploadDownloadConstant'
import { IoIosClose, IoMdSearch } from "react-icons/io";
import { CleanersAdminDownloadSchedule } from "../../../CleanersDashboardAdminAPI/CleanersAdminDownloadScheduleApi";
import { CleanersAdminUploadSchedule } from "../../../CleanersDashboardAdminAPI/CleanersAdminUploadScheduleAPI";
import { CleanersAdminVendorGetFileLogs } from "../../../CleanersDashboardAdminAPI/CleanersAdminGetFileLogsAPi";
import { IconContext } from "react-icons";
import { make_cols } from './MakeColumns';
import { ReactSVG } from 'react-svg'
import { SheetJSFT } from './types';
import moment from "moment";
import XLSX from 'xlsx';
import DashboardCleanersAdminHeader from '../../../CleanersDashboardComponents/Shared/DashboardCleanersAdminHeader/DashboardCleanersAdminHeader'
import { file } from '@babel/types';
const FileDownload = require('js-file-download');



class DashboardScheduleUploadDownload extends Component {
    constructor(props) {
        super(props)
        this.state = {
            file: {},
            data: [],
            cols: [],
            finalData: [],
            loading: false,
            loadingMessage: false,
            fileLength: false,
            disableCancelUpload: false,
            UploadSucess: false,
            arrayFileLogs: [],
            error404 :false,
            error401 :false,
            error500 :false,
            error400 :false,
            fileName : '',
            NoUploadHistory : false,
            EmptyFile: false

        }
        this.handleClose = this.handleClose.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.loadFileLogs = this.loadFileLogs.bind(this);

    }
    componentWillMount() {
        this.loadFileLogs();
    }
    loadFileLogs() {
        this.setState({
            loading: true
        })
        let arrayFileLogs = []
        let UserId = sessionStorage.getItem('userId')
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        CleanersAdminVendorGetFileLogs(UserId, AuthStr).then(res => {
            if (res.status == 200) {
                this.setState({
                    loading: false
                })
                let FileLogsArray = res.data.fileName
                Object.keys(FileLogsArray).forEach(function (key) {
                    arrayFileLogs.push({
                        FileName: FileLogsArray[key].fileName,
                        UploadDate: FileLogsArray[key].uploadTime.split("T")[0]
                    })
                })
                this.setState({
                    arrayFileLogs: arrayFileLogs
                })
                if(res.data.fileName.length == 0) {
                    this.setState({
                        NoUploadHistory : true
                    })
                }
            }
            else if (res.status == 401) {
                this.setState({
                    error401: true,
                    loading: false
                })
            }
            else if (res.status == 404) {
                this.setState({
                    error404: true,
                    loading: false
                })
            }
            else if (res.status == 500) {
                this.setState({
                    error500: true,
                    loading: false
                })
            }
            else if (res.status == 400) {
                this.setState({
                    error400: true,
                    loading: false
                })
            }
        })

    }
    handleDownload() {
        this.setState({
            loading: true
        })
        let UserId = sessionStorage.getItem('userId')
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        CleanersAdminDownloadSchedule(UserId, AuthStr).then(res => {
            if (res.status == 200) {
                this.setState({
                    loading: false
                })
                let TodaysDate = this.formatDate(moment())
                FileDownload(res.data, 'Downloaded_CleanerSchedule_' + TodaysDate + '.csv');
            }
            else if (res.status == 401) {
                this.setState({
                    error401: true,
                    loading: false
                })
            }
            else if (res.status == 404) {
                this.setState({
                    error404: true,
                    loading: false
                })
            }
            else if (res.status == 500) {
                this.setState({
                    error500: true,
                    loading: false
                })
            }
            else if (res.status == 400) {
                this.setState({
                    error400: true,
                    loading: false
                })
            }
        })
    }
    formatDate(string) {
        var options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(string).toLocaleDateString([], options);
    }

    handleClose() {
        this.setState({
            UploadSucess : false
        })
    }
    handleChange(e) {
        const files = e.target.files;
        if (files.length > 0) {
            this.setState({
                fileLength: true,
                fileName : files[0].name.split(".")[0],
                EmptyFile : false
            })
        }
        if (files && files[0]) this.setState({ file: files[0] });
    };

    handleFile() {

        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;

        reader.onload = (e) => {
            /* Parse data */
            const bstr = e.target.result;
            // const wb = XLSX.read(bstr, { type:  'binary' });
             const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
           
            /* Get first worksheet */
       
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
          
            let FileName = wsname
            /* Convert array of arrays */
            
            const data = XLSX.utils.sheet_to_json(ws, { header: ["Store No", "Verisae Number", "Store Name", "Supplier Name", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"], origin: { r: 3, c: 0 },blankrows : false});
            /* Update state */
            this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
            });
            if(this.state.cols == "No data in file" || data.length == 0) {
              
               this.setState({
                EmptyFile: true
               })
            }
            else
             {
            let arr = []
            
            arr = data.slice(0); // make copy

             arr.splice(0, 1);  
            //  arr.splice(0, 1);
            this.setState({
                finalData: arr,
                loadingMessage: true,
                fileLength: false
            })
            let AuthData = {
                FileName: this.state.fileName,
                Data: JSON.stringify(arr, null, 2),
                UserId: sessionStorage.getItem('userId')
            }
            this.setState({
                loading : true
            })
            let TokenDataApi = sessionStorage.getItem('token');
            const AuthStr = 'bearer '.concat(TokenDataApi);
            CleanersAdminUploadSchedule(AuthData, AuthStr).then(res => {
                if (res.status == 200) {
                    this.setState({
                        UploadSucess: true,
                        loadingMessage: false,
                        loading : false,
                        NoUploadHistory : false
                    })
                   
                    document.getElementById("file").value = "";
                    this.loadFileLogs();
                }
                else if (res.status == 401) {
                    this.setState({
                        error401: true,
                        loading: false
                    })
                }
                else if (res.status == 404) {
                    this.setState({
                        error404: true,
                        loading: false
                    })
                }
                else if (res.status == 500) {
                    this.setState({
                        error500: true,
                        loading: false
                    })
                }
                else if (res.status == 400) {
                    this.setState({
                        error400: true,
                        loading: false
                    })
                }
            })
        }
        };

        if (rABS) {
            reader.readAsBinaryString(this.state.file);
        } else {
            reader.readAsArrayBuffer(this.state.file);
        };
    }

    render() {
        if (this.state.redirectLogin) {
            return (<Redirect to={'/DashboardLogin'} />)
        }
        if (this.state.error400) {
            return (<Redirect to={'/CleanersAdminDashboardError400'} />)
        }
        if (this.state.error401) {
            return (<Redirect to={'/CleanersAdminDashboardError401'} />)
        }
        if (this.state.error404) {
            return (<Redirect to={'/CleanersAdminDashboardError404'} />)
        }
        if (this.state.error500) {
            return (<Redirect to={'/CleanersAdminDashboardError500'} />)
        }

        return (
            <div>
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                <DashboardCleanersAdminHeader />
                {this.state.UploadSucess ? <div className="loadingUploadedMessage"><p className="messageUploaded">{DashboardScheduleUploadDownloadConstant.FileUploaded}<span><IoIosClose className="UpdateClose"  onClick={this.handleClose}/></span></p> </div> : null}
                <div className="UploadTab">
                <div className="modifySchedule">
                    <h3>{DashboardScheduleUploadDownloadConstant.NewScheduleCleaning}</h3>
                    {this.state.EmptyFile ? <div><span className="EmptyFile">{DashboardScheduleUploadDownloadConstant.EmptyUploadFile}</span></div> : null }
                    <p>{DashboardScheduleUploadDownloadConstant.UploadFile}<span className="mandatoryField">*</span></p>
                    <div className="flexHead">
                        <ReusableTextBox type="file" role="textbox" className="UploadTextbox" id="file" accept=".csv, .xls , .xlsx , .xlsm ,. xlsb" onChange={this.handleChange} />
                        <div className="UploadDownload">
                        {this.state.loading ?
                            <ReusableButton type="button" className="UploadLoading" buttonText={DashboardScheduleUploadDownloadConstant.Upload} disabled={!(this.state.fileLength)} onClick={this.handleFile}></ReusableButton> :
                            <ReusableButton type="button" className="Upload" buttonText={DashboardScheduleUploadDownloadConstant.Upload} disabled={!(this.state.fileLength)} onClick={this.handleFile}></ReusableButton>

                        }
                        <ReusableButton type="button" className="Download" onClick={this.handleDownload} buttonText={DashboardScheduleUploadDownloadConstant.Download}></ReusableButton>
                        </div>
                    </div>
                    {this.state.loadingMessage ? <div className="loadingMessage"><p className="message">{DashboardScheduleUploadDownloadConstant.Uploading}</p> </div> : null}
                 
                </div>
                <div className="FileLogs">
                    <table className="TableFileLogs">
                        <thead>
                            <th>{DashboardScheduleUploadDownloadConstant.FileName}</th>
                            <th>{DashboardScheduleUploadDownloadConstant.UploadDate}</th>
                        </thead>
                        <tbody>
                            {this.state.arrayFileLogs.map((x,key) =>
                            <tr key={key}>
                             <td>{x.FileName}</td>
                             <td>{this.formatDate(x.UploadDate)}</td>
                             </tr>
                            )}  
                                {this.state.NoUploadHistory ? 
                              <tr>
                              <td colspan="2">{DashboardScheduleUploadDownloadConstant.UploadHistory}</td></tr> : null
                        }
                        </tbody>

                    </table>
                </div>
                </div>
            </div>
        )
    }
}

export default DashboardScheduleUploadDownload;
